// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__Cqsz4","file":"styles_file__1kMJs"};